import { action, Action } from 'typesafe-actions';

import { PrefsState, PrefsActionEnum } from './types';

export const updatePrefsAction = (state: Partial<PrefsState>): Action =>
	action(PrefsActionEnum.Update, state);
